import jssVariables from "../../jss_setup";

export const footer = {
  logo: {
    height: "5rem",
    marginBottom: jssVariables.double_gap,
    smallscreen: {
      height: "5rem",
    },
  },
  footer: {
    background: jssVariables.colors.base_color,
    paddingTop: jssVariables.navbar_height,
    paddingBottom: `calc(${jssVariables.navbar_height} * 1.5)`,
    smallscreen: {
      alignItems: "end",
      paddingBottom: `calc(${jssVariables.navbar_height} * 1.5)`,
    },
  },
  section: {
    color: "white",
  },
  group: {
    color: "white",
  },
  groupContactInfo: {
    color: "white",
  },
  groupIcon: {
    color: "white",
  },
  icon: {
    color: "white",
  },
  socialMediaLabel: {
    color: "white",
  },
};

export const PoweredBy = {
  PoweredBy: {
    smallscreen: {
      left: "unset",
      right: jssVariables.navbar_height,
    },
  },
};
